export default __webpack_public_path__ + "static/media/DrSaab.4f28174c.svg";